module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Reason")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflowDetails),
      expression: "workflowDetails"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add reason",
      "id": "reason"
    },
    domProps: {
      "value": (_vm.workflowDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.workflowDetails = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": _vm.sanction_outcome.commsLogsDocumentUrl
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorResponse)
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.processingDetails) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Adding")]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c64c28fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/sanction_outcome/sanction_outcome_workflow.vue
// module id = 1050
// module chunks = 0